<template lang="html">
  <header>
    <v-app-bar dense flat class="white">
      <!-- <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon> -->

      <v-tabs>
        <v-tab
          v-for="(menuItem, index) in menuItems"
          :key="index"
          :to="menuItem.url"
        >
          {{ menuItem.name }}
        </v-tab>
        <v-tabs-slider color="light-blue darken-2"></v-tabs-slider>
        <!-- v-tabs-slider カラーのプロパティでアンダーバーの色設定できた-->
      </v-tabs>
    </v-app-bar>
    <!-- ここからドロワー -->
    <!-- <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :to="menuItem.url"
          >
            <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer> -->
    <!-- ここまで -->
  </header>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
        menuItems: [
          {
            name: "トップ",
            url: "/",
          },
          {
            name: "商品情報",
            url: "/product",
          },
        ],
      };
    },
  };
</script>

<style scoped>
  @import "../styles/common/css/pageprimary.css";
</style>
